// Generated by backend/scripts/seed_water_withdrawal_discharge_recycle.py - do not edit
export const WORKFORCE_GRID_CONFIGS = {
 "New Employees/Worker": {
  "key": "new_hires",
  "title": "New Employees/Worker",
  "editableAutoTotals": true,
  "columns": [
   {
    "key": "female",
    "label": "Female"
   },
   {
    "key": "male",
    "label": "Male"
   },
   {
    "key": "total",
    "label": "Total"
   }
  ],
  "autoCalculate": {
   "total": [
    "female",
    "male"
   ]
  },
  "rows": [
   {
    "key": "total",
    "label": "New hires (Total)",
    "group": "Total",
    "level": 0,
    "brsr": null,
    "gri": "401-1-a; 102-3-a, 102-3-e",
    "sumOf": [
     "employees",
     "workers"
    ]
   },
   {
    "key": "employees",
    "label": "Employees",
    "group": "By Employment Type",
    "level": 1,
    "brsr": null,
    "gri": "401-1-a; 102-3-a",
    "sumOf": [
     "employees_permanent",
     "employees_other"
    ]
   },
   {
    "key": "employees_permanent",
    "label": "Employees - Permanent",
    "group": "By Employment Type",
    "level": 2,
    "brsr": null,
    "gri": "102-3-a-ii",
    "sumOf": null
   },
   {
    "key": "employees_other",
    "label": "Employees - Other than permanent",
    "group": "By Employment Type",
    "level": 2,
    "brsr": null,
    "gri": "102-3-a-ii",
    "sumOf": null
   },
   {
    "key": "workers",
    "label": "Workers",
    "group": "By Employment Type",
    "level": 1,
    "brsr": null,
    "gri": "102-3-e",
    "sumOf": [
     "workers_permanent",
     "workers_other"
    ]
   },
   {
    "key": "workers_permanent",
    "label": "Workers - Permanent",
    "group": "By Employment Type",
    "level": 2,
    "brsr": null,
    "gri": "102-3-e",
    "sumOf": null
   },
   {
    "key": "workers_other",
    "label": "Workers - Other than permanent",
    "group": "By Employment Type",
    "level": 2,
    "brsr": null,
    "gri": "102-3-e",
    "sumOf": null
   },
   {
    "key": "age_u30",
    "label": "Under 30",
    "group": "By Age Group",
    "level": 1,
    "brsr": null,
    "gri": "401-1-a",
    "sumOf": null
   },
   {
    "key": "age_3050",
    "label": "30-50",
    "group": "By Age Group",
    "level": 1,
    "brsr": null,
    "gri": "401-1-a",
    "sumOf": null
   },
   {
    "key": "age_o50",
    "label": "Over 50",
    "group": "By Age Group",
    "level": 1,
    "brsr": null,
    "gri": "401-1-a",
    "sumOf": null
   }
  ],
  "sumOrder": [
   "employees",
   "workers",
   "total"
  ],
  "fieldMap": {
   "total": {
    "female": "female",
    "male": "male",
    "total": "total_no_of_people_hired"
   },
   "employees": {
    "female": "new_hires_employees_female",
    "male": "new_hires_employees_male",
    "total": "new_hires_employees"
   },
   "employees_permanent": {
    "female": "new_hires_employees_permanent_female",
    "male": "new_hires_employees_permanent_male",
    "total": "new_hires_employees_permanent"
   },
   "employees_other": {
    "female": "new_hires_employees_other_female",
    "male": "new_hires_employees_other_male",
    "total": "new_hires_employees_other_than_permanent"
   },
   "workers": {
    "female": "new_hires_workers_female",
    "male": "new_hires_workers_male",
    "total": "new_hires_workers"
   },
   "workers_permanent": {
    "female": "new_hires_workers_permanent_female",
    "male": "new_hires_workers_permanent_male",
    "total": "new_hires_workers_permanent"
   },
   "workers_other": {
    "female": "new_hires_workers_other_female",
    "male": "new_hires_workers_other_male",
    "total": "new_hires_workers_other_than_permanent"
   },
   "age_u30": {
    "female": "new_hires_age_u30_female",
    "male": "new_hires_age_u30_male",
    "total": "no_of_employees_worker_under_30"
   },
   "age_3050": {
    "female": "new_hires_age_3050_female",
    "male": "new_hires_age_3050_male",
    "total": "no_of_employees_worker_30_50"
   },
   "age_o50": {
    "female": "new_hires_age_o50_female",
    "male": "new_hires_age_o50_male",
    "total": "no_of_employees_worker_over_50"
   }
  },
  "validations": [
   {
    "type": "sum_equals",
    "rows": [
     "age_u30",
     "age_3050",
     "age_o50"
    ],
    "target": "total"
   }
  ]
 },
 "Terminated Employees": {
  "key": "term_emp",
  "title": "Terminated Employees",
  "editableAutoTotals": true,
  "columns": [
   {
    "key": "female",
    "label": "Female"
   },
   {
    "key": "male",
    "label": "Male"
   },
   {
    "key": "total",
    "label": "Total"
   }
  ],
  "autoCalculate": {
   "total": [
    "female",
    "male"
   ]
  },
  "rows": [
   {
    "key": "total",
    "label": "Employees terminated (Total)",
    "group": "Total",
    "level": 0,
    "brsr": "A-22",
    "gri": "102-3-b; 401-1-b",
    "sumOf": [
     "permanent",
     "temporary",
     "contract",
     "part_time",
     "intern"
    ]
   },
   {
    "key": "permanent",
    "label": "Permanent",
    "group": "By Employment Type",
    "level": 1,
    "brsr": "A-22",
    "gri": "102-3-b-ii",
    "sumOf": null
   },
   {
    "key": "temporary",
    "label": "Temporary",
    "group": "By Employment Type",
    "level": 1,
    "brsr": null,
    "gri": "102-3-b-ii",
    "sumOf": null
   },
   {
    "key": "contract",
    "label": "Contract",
    "group": "By Employment Type",
    "level": 1,
    "brsr": null,
    "gri": "102-3-b-ii",
    "sumOf": null
   },
   {
    "key": "part_time",
    "label": "Part-time",
    "group": "By Employment Type",
    "level": 1,
    "brsr": null,
    "gri": "102-3-b-ii",
    "sumOf": null
   },
   {
    "key": "intern",
    "label": "Intern / trainee",
    "group": "By Employment Type",
    "level": 1,
    "brsr": null,
    "gri": "102-3-b-ii",
    "sumOf": null
   }
  ],
  "sumOrder": [
   "total"
  ],
  "fieldMap": {
   "total": {
    "female": "female",
    "male": "male",
    "total": "no_of_people_terminated"
   },
   "permanent": {
    "female": "term_emp_permanent_female",
    "male": "term_emp_permanent_male",
    "total": "no_of_permanent_employee_terminated"
   },
   "temporary": {
    "female": "term_emp_temporary_female",
    "male": "term_emp_temporary_male",
    "total": "no_of_temporary_employee_terminated"
   },
   "contract": {
    "female": "term_emp_contract_female",
    "male": "term_emp_contract_male",
    "total": "no_of_contract_employee_terminated"
   },
   "part_time": {
    "female": "term_emp_part_time_female",
    "male": "term_emp_part_time_male",
    "total": "no_of_part_time_employee_terminated"
   },
   "intern": {
    "female": "term_emp_intern_female",
    "male": "term_emp_intern_male",
    "total": "no_of_intern_trainee_terminated"
   }
  },
  "validations": []
 },
 "Terminated Workers": {
  "key": "term_wrk",
  "title": "Terminated Workers",
  "editableAutoTotals": true,
  "columns": [
   {
    "key": "female",
    "label": "Female"
   },
   {
    "key": "male",
    "label": "Male"
   },
   {
    "key": "total",
    "label": "Total"
   }
  ],
  "autoCalculate": {
   "total": [
    "female",
    "male"
   ]
  },
  "rows": [
   {
    "key": "total",
    "label": "Workers terminated (Total)",
    "group": "Total",
    "level": 0,
    "brsr": "A-22",
    "gri": "102-3-f; 401-1-b",
    "sumOf": null
   }
  ],
  "sumOrder": [],
  "fieldMap": {
   "total": {
    "female": "no_of_female_terminated",
    "male": "no_of_male_terminated",
    "total": "no_of_workers_terminated"
   }
  },
  "validations": []
 },
 "Employee Diversity": {
  "key": "emp_div",
  "title": "Employee Diversity",
  "editableAutoTotals": false,
  "columns": [
   {
    "key": "female",
    "label": "Female"
   },
   {
    "key": "male",
    "label": "Male"
   },
   {
    "key": "total",
    "label": "Total"
   }
  ],
  "autoCalculate": {
   "total": [
    "female",
    "male"
   ]
  },
  "rows": [
   {
    "key": "total",
    "label": "Total Employees",
    "group": "Total",
    "level": 0,
    "brsr": "A-20a (D+E)",
    "gri": "2-7-a; 405-1-b",
    "sumOf": [
     "permanent",
     "other_than_permanent"
    ]
   },
   {
    "key": "permanent",
    "label": "Permanent employees",
    "group": "By Contract Type",
    "level": 1,
    "brsr": "A-20a (D)",
    "gri": "2-7-b-i",
    "sumOf": null
   },
   {
    "key": "other_than_permanent",
    "label": "Other-than-permanent employees",
    "group": "By Contract Type",
    "level": 1,
    "brsr": "A-20a (E)",
    "gri": "2-7-b-ii",
    "sumOf": [
     "temporary",
     "contract",
     "intern"
    ]
   },
   {
    "key": "temporary",
    "label": "Temporary",
    "group": "By Contract Type",
    "level": 2,
    "brsr": "A-20a (E)",
    "gri": "2-7-b-ii",
    "sumOf": null
   },
   {
    "key": "contract",
    "label": "Contract",
    "group": "By Contract Type",
    "level": 2,
    "brsr": "A-20a (E)",
    "gri": "2-7-b-ii, 2-8-a",
    "sumOf": null
   },
   {
    "key": "intern",
    "label": "Intern / trainee",
    "group": "By Contract Type",
    "level": 2,
    "brsr": "A-20a (E)",
    "gri": "2-7-b-ii, 2-8-a",
    "sumOf": null
   },
   {
    "key": "full_time",
    "label": "Full-time employees",
    "group": "By Working Hours",
    "level": 1,
    "brsr": null,
    "gri": "2-7-b-iv",
    "sumOf": null
   },
   {
    "key": "part_time",
    "label": "Part-time employees",
    "group": "By Working Hours",
    "level": 1,
    "brsr": null,
    "gri": "2-7-b-v",
    "sumOf": null
   },
   {
    "key": "age_u30",
    "label": "Under 30",
    "group": "By Age Group",
    "level": 1,
    "brsr": null,
    "gri": "405-1-b-ii",
    "sumOf": null
   },
   {
    "key": "age_3050",
    "label": "30-50",
    "group": "By Age Group",
    "level": 1,
    "brsr": null,
    "gri": "405-1-b-ii",
    "sumOf": null
   },
   {
    "key": "age_o50",
    "label": "Over 50",
    "group": "By Age Group",
    "level": 1,
    "brsr": null,
    "gri": "405-1-b-ii",
    "sumOf": null
   },
   {
    "key": "minority",
    "label": "of which: Minority-group employees",
    "group": "Diversity Groups (subsets)",
    "level": 1,
    "brsr": null,
    "gri": "405-1-b-iii",
    "sumOf": null
   },
   {
    "key": "vulnerable",
    "label": "of which: Vulnerable-group employees",
    "group": "Diversity Groups (subsets)",
    "level": 1,
    "brsr": "A-20b",
    "gri": "405-1-b-iii",
    "sumOf": null
   },
   {
    "key": "differently_abled",
    "label": "Differently-abled employees",
    "group": "Diversity Groups (subsets)",
    "level": 1,
    "brsr": "A-20b (D+E)",
    "gri": "405-1-b-iii",
    "sumOf": [
     "da_permanent",
     "da_other_than_permanent"
    ]
   },
   {
    "key": "da_permanent",
    "label": "Differently-abled - Permanent",
    "group": "Diversity Groups (subsets)",
    "level": 2,
    "brsr": "A-20b (D)",
    "gri": "405-1-b-iii",
    "sumOf": null
   },
   {
    "key": "da_other_than_permanent",
    "label": "Differently-abled - Other than permanent",
    "group": "Diversity Groups (subsets)",
    "level": 2,
    "brsr": "A-20b (E)",
    "gri": "405-1-b-iii",
    "sumOf": null
   }
  ],
  "sumOrder": [
   "other_than_permanent",
   "differently_abled",
   "total"
  ],
  "fieldMap": {
   "total": {
    "female": "no_of_female",
    "male": "no_of_male",
    "total": "no_of_employees"
   },
   "permanent": {
    "female": "no_of_female_permanent_employees",
    "male": "no_of_male_permanent_employees",
    "total": "no_of_permanent_employees"
   },
   "other_than_permanent": {
    "female": "emp_div_other_than_permanent_female",
    "male": "emp_div_other_than_permanent_male",
    "total": "emp_div_other_than_permanent_total"
   },
   "temporary": {
    "female": "no_of_female_temporary_employees",
    "male": "no_of_male_temporary_employees",
    "total": "no_of_temporary_employees"
   },
   "contract": {
    "female": "no_of_female_contract_employees",
    "male": "no_of_male_contract_employees",
    "total": "no_of_contract_employees"
   },
   "intern": {
    "female": "no_of_female_intern_trainee",
    "male": "no_of_male_intern_trainee",
    "total": "no_of_intern_trainee"
   },
   "full_time": {
    "female": "emp_div_full_time_female",
    "male": "emp_div_full_time_male",
    "total": "emp_div_full_time_total"
   },
   "part_time": {
    "female": "no_of_female_part_time_employees",
    "male": "no_of_male_part_time_employees",
    "total": "no_of_part_time_employees"
   },
   "age_u30": {
    "female": "no_of_female_employees_age_under_30",
    "male": "no_of_male_employees_age_under_30",
    "total": "no_of_employees_under_30"
   },
   "age_3050": {
    "female": "no_of_female_employees_age_30_50",
    "male": "no_of_male_employees_age_30_50",
    "total": "no_of_employees_30_50"
   },
   "age_o50": {
    "female": "no_of_female_employees_age_over_50",
    "male": "no_of_male_employees_age_over_50",
    "total": "no_of_employees_over_50"
   },
   "minority": {
    "female": "no_of_female_employees_belonging_to_minority",
    "male": "no_of_male_employees_belonging_to_minority",
    "total": "no_of_employees_minority"
   },
   "vulnerable": {
    "female": "no_of_female_employees_belonging_to_vulnerable_groups",
    "male": "no_of_male_employees_belonging_to_vulnerable_groups",
    "total": "no_of_employees_vulnerable_groups"
   },
   "differently_abled": {
    "female": "emp_div_differently_abled_female",
    "male": "emp_div_differently_abled_male",
    "total": "emp_div_differently_abled_total"
   },
   "da_permanent": {
    "female": "emp_div_da_permanent_female",
    "male": "emp_div_da_permanent_male",
    "total": "emp_div_da_permanent_total"
   },
   "da_other_than_permanent": {
    "female": "emp_div_da_other_than_permanent_female",
    "male": "emp_div_da_other_than_permanent_male",
    "total": "emp_div_da_other_than_permanent_total"
   }
  },
  "validations": [
   {
    "type": "sum_equals",
    "rows": [
     "full_time",
     "part_time"
    ],
    "target": "total"
   },
   {
    "type": "sum_equals",
    "rows": [
     "age_u30",
     "age_3050",
     "age_o50"
    ],
    "target": "total"
   },
   {
    "type": "less_than_or_equal",
    "row": "minority",
    "target": "total"
   },
   {
    "type": "less_than_or_equal",
    "row": "vulnerable",
    "target": "total"
   },
   {
    "type": "less_than_or_equal",
    "row": "differently_abled",
    "target": "total"
   }
  ]
 },
 "Workers Diversity": {
  "key": "wrk_div",
  "title": "Workers Diversity",
  "editableAutoTotals": false,
  "columns": [
   {
    "key": "female",
    "label": "Female"
   },
   {
    "key": "male",
    "label": "Male"
   },
   {
    "key": "total",
    "label": "Total"
   }
  ],
  "autoCalculate": {
   "total": [
    "female",
    "male"
   ]
  },
  "rows": [
   {
    "key": "total",
    "label": "Total Workers",
    "group": "Total",
    "level": 0,
    "brsr": "A-20a (F+G)",
    "gri": "2-7-a, 2-8-a; 405-1-b",
    "sumOf": [
     "permanent",
     "other_than_permanent"
    ]
   },
   {
    "key": "permanent",
    "label": "Permanent workers",
    "group": "By Contract Type",
    "level": 1,
    "brsr": "A-20a (F)",
    "gri": "2-7-b-i",
    "sumOf": null
   },
   {
    "key": "other_than_permanent",
    "label": "Other-than-permanent workers",
    "group": "By Contract Type",
    "level": 1,
    "brsr": "A-20a (G)",
    "gri": "2-8-a",
    "sumOf": null
   },
   {
    "key": "age_u30",
    "label": "Under 30",
    "group": "By Age Group",
    "level": 1,
    "brsr": null,
    "gri": "405-1-b-ii",
    "sumOf": null
   },
   {
    "key": "age_3050",
    "label": "30-50",
    "group": "By Age Group",
    "level": 1,
    "brsr": null,
    "gri": "405-1-b-ii",
    "sumOf": null
   },
   {
    "key": "age_o50",
    "label": "Over 50",
    "group": "By Age Group",
    "level": 1,
    "brsr": null,
    "gri": "405-1-b-ii",
    "sumOf": null
   },
   {
    "key": "minority",
    "label": "of which: Minority-group workers",
    "group": "Diversity Groups (subsets)",
    "level": 1,
    "brsr": null,
    "gri": "405-1-b-iii",
    "sumOf": null
   },
   {
    "key": "vulnerable",
    "label": "of which: Vulnerable-group workers",
    "group": "Diversity Groups (subsets)",
    "level": 1,
    "brsr": "A-20b",
    "gri": "405-1-b-iii",
    "sumOf": null
   },
   {
    "key": "differently_abled",
    "label": "Differently-abled workers",
    "group": "Diversity Groups (subsets)",
    "level": 1,
    "brsr": "A-20b (F+G)",
    "gri": "405-1-b-iii",
    "sumOf": [
     "da_permanent",
     "da_other_than_permanent"
    ]
   },
   {
    "key": "da_permanent",
    "label": "Differently-abled - Permanent",
    "group": "Diversity Groups (subsets)",
    "level": 2,
    "brsr": "A-20b (F)",
    "gri": "405-1-b-iii",
    "sumOf": null
   },
   {
    "key": "da_other_than_permanent",
    "label": "Differently-abled - Other than permanent",
    "group": "Diversity Groups (subsets)",
    "level": 2,
    "brsr": "A-20b (G)",
    "gri": "405-1-b-iii",
    "sumOf": null
   }
  ],
  "sumOrder": [
   "total",
   "differently_abled"
  ],
  "fieldMap": {
   "total": {
    "female": "no_of_female_workers",
    "male": "no_of_male_workers",
    "total": "no_of_workers"
   },
   "permanent": {
    "female": "wrk_div_permanent_female",
    "male": "wrk_div_permanent_male",
    "total": "wrk_div_permanent_total"
   },
   "other_than_permanent": {
    "female": "wrk_div_other_than_permanent_female",
    "male": "wrk_div_other_than_permanent_male",
    "total": "wrk_div_other_than_permanent_total"
   },
   "age_u30": {
    "female": "no_of_female_workers_age_under_30",
    "male": "no_of_male_workers_age_under_30",
    "total": "no_of_workers_under_30"
   },
   "age_3050": {
    "female": "no_of_female_workers_age_30_50",
    "male": "no_of_male_workers_age_30_50",
    "total": "no_of_workers_30_50"
   },
   "age_o50": {
    "female": "no_of_female_workers_age_over_50",
    "male": "no_of_male_workers_age_over_50",
    "total": "no_of_workers_over_50"
   },
   "minority": {
    "female": "no_of_female_workers_belonging_to_minority",
    "male": "no_of_male_workers_belonging_to_minority",
    "total": "no_of_workers_belonging_to_minority"
   },
   "vulnerable": {
    "female": "no_of_female_workers_belonging_to_vulnerable_groups",
    "male": "no_of_male_workers_belonging_to_vulnerable_groups",
    "total": "no_of_workers_belonging_to_vulnerable_groups"
   },
   "differently_abled": {
    "female": "wrk_div_differently_abled_female",
    "male": "wrk_div_differently_abled_male",
    "total": "wrk_div_differently_abled_total"
   },
   "da_permanent": {
    "female": "wrk_div_da_permanent_female",
    "male": "wrk_div_da_permanent_male",
    "total": "wrk_div_da_permanent_total"
   },
   "da_other_than_permanent": {
    "female": "wrk_div_da_other_than_permanent_female",
    "male": "wrk_div_da_other_than_permanent_male",
    "total": "wrk_div_da_other_than_permanent_total"
   }
  },
  "validations": [
   {
    "type": "sum_equals",
    "rows": [
     "age_u30",
     "age_3050",
     "age_o50"
    ],
    "target": "total"
   },
   {
    "type": "less_than_or_equal",
    "row": "minority",
    "target": "total"
   },
   {
    "type": "less_than_or_equal",
    "row": "vulnerable",
    "target": "total"
   },
   {
    "type": "less_than_or_equal",
    "row": "differently_abled",
    "target": "total"
   }
  ]
 },
 "Board of Directors Diversity": {
  "key": "bod_div",
  "title": "Board of Directors Diversity",
  "editableAutoTotals": false,
  "columns": [
   {
    "key": "female",
    "label": "Female"
   },
   {
    "key": "male",
    "label": "Male"
   },
   {
    "key": "total",
    "label": "Total"
   }
  ],
  "autoCalculate": {
   "total": [
    "female",
    "male"
   ]
  },
  "rows": [
   {
    "key": "total",
    "label": "Board of Directors (Total)",
    "group": "Total",
    "level": 0,
    "brsr": "A-21",
    "gri": "405-1-a; 2-9-c",
    "sumOf": null
   },
   {
    "key": "age_u30",
    "label": "Under 30",
    "group": "By Age Band",
    "level": 1,
    "brsr": null,
    "gri": "405-1-a-ii",
    "sumOf": null
   },
   {
    "key": "age_3050",
    "label": "30-50",
    "group": "By Age Band",
    "level": 1,
    "brsr": null,
    "gri": "405-1-a-ii",
    "sumOf": null
   },
   {
    "key": "age_o50",
    "label": "Over 50",
    "group": "By Age Band",
    "level": 1,
    "brsr": null,
    "gri": "405-1-a-ii",
    "sumOf": null
   },
   {
    "key": "minority",
    "label": "of which: Minority-group members",
    "group": "Diversity Groups (subsets)",
    "level": 1,
    "brsr": null,
    "gri": "405-1-a-iii",
    "sumOf": null
   },
   {
    "key": "vulnerable",
    "label": "of which: Vulnerable-group members",
    "group": "Diversity Groups (subsets)",
    "level": 1,
    "brsr": null,
    "gri": "405-1-a-iii",
    "sumOf": null
   }
  ],
  "sumOrder": [],
  "fieldMap": {
   "total": {
    "female": "no_of_female",
    "male": "no_of_male",
    "total": "bod_div_total_total"
   },
   "age_u30": {
    "female": "no_of_female_employees_under_30",
    "male": "no_of_male_employees_under_30",
    "total": "no_of_employees_under_30"
   },
   "age_3050": {
    "female": "no_of_female_employees_age_30_50",
    "male": "no_of_male_employees_age_30_50",
    "total": "no_of_employees_age_30_50"
   },
   "age_o50": {
    "female": "no_of_female_employees_over_50",
    "male": "no_of_male_employees_over_50",
    "total": "no_of_employees_over_50"
   },
   "minority": {
    "female": "no_of_female_employees_belonging_to_minority",
    "male": "no_of_male_employees_belonging_to_minority",
    "total": "no_of_employees_belonging_to_minority"
   },
   "vulnerable": {
    "female": "no_of_female_employees_belonging_to_vulnerable_groups",
    "male": "no_of_male_employees_belonging_to_vulnerable_groups",
    "total": "no_of_employees_belonging_to_vulnerable_groups"
   }
  },
  "validations": [
   {
    "type": "sum_equals",
    "rows": [
     "age_u30",
     "age_3050",
     "age_o50"
    ],
    "target": "total"
   },
   {
    "type": "less_than_or_equal",
    "row": "minority",
    "target": "total"
   },
   {
    "type": "less_than_or_equal",
    "row": "vulnerable",
    "target": "total"
   }
  ]
 },
 "Key Management Personnel Diversity": {
  "key": "kmp_div",
  "title": "Key Management Personnel Diversity",
  "editableAutoTotals": false,
  "columns": [
   {
    "key": "female",
    "label": "Female"
   },
   {
    "key": "male",
    "label": "Male"
   },
   {
    "key": "total",
    "label": "Total"
   }
  ],
  "autoCalculate": {
   "total": [
    "female",
    "male"
   ]
  },
  "rows": [
   {
    "key": "total",
    "label": "Key Management Personnel (Total)",
    "group": "Total",
    "level": 0,
    "brsr": "A-21",
    "gri": "405-1-a",
    "sumOf": null
   },
   {
    "key": "age_u30",
    "label": "Under 30",
    "group": "By Age Band",
    "level": 1,
    "brsr": null,
    "gri": "405-1-a-ii",
    "sumOf": null
   },
   {
    "key": "age_3050",
    "label": "30-50",
    "group": "By Age Band",
    "level": 1,
    "brsr": null,
    "gri": "405-1-a-ii",
    "sumOf": null
   },
   {
    "key": "age_o50",
    "label": "Over 50",
    "group": "By Age Band",
    "level": 1,
    "brsr": null,
    "gri": "405-1-a-ii",
    "sumOf": null
   },
   {
    "key": "minority",
    "label": "of which: Minority-group members",
    "group": "Diversity Groups (subsets)",
    "level": 1,
    "brsr": null,
    "gri": "405-1-a-iii",
    "sumOf": null
   },
   {
    "key": "vulnerable",
    "label": "of which: Vulnerable-group members",
    "group": "Diversity Groups (subsets)",
    "level": 1,
    "brsr": null,
    "gri": "405-1-a-iii",
    "sumOf": null
   }
  ],
  "sumOrder": [],
  "fieldMap": {
   "total": {
    "female": "no_of_female",
    "male": "no_of_male",
    "total": "kmp_div_total_total"
   },
   "age_u30": {
    "female": "no_of_female_employees_under_30",
    "male": "no_of_male_employees_under_30",
    "total": "no_of_employees_under_30"
   },
   "age_3050": {
    "female": "no_of_female_employees_age_30_50",
    "male": "no_of_male_employees_age_30_50",
    "total": "no_of_employees_30_50"
   },
   "age_o50": {
    "female": "no_of_female_employees_over_50",
    "male": "no_of_male_employees_over_50",
    "total": "no_of_employees_over_50"
   },
   "minority": {
    "female": "no_of_female_employees_belonging_to_minority",
    "male": "no_of_male_employees_belonging_to_minority",
    "total": "no_of_employees_minority"
   },
   "vulnerable": {
    "female": "no_of_female_employees_belonging_to_vulnerable_groups",
    "male": "no_of_male_employees_belonging_to_vulnerable_groups",
    "total": "no_of_employees_vulnerable_groups"
   }
  },
  "validations": [
   {
    "type": "sum_equals",
    "rows": [
     "age_u30",
     "age_3050",
     "age_o50"
    ],
    "target": "total"
   },
   {
    "type": "less_than_or_equal",
    "row": "minority",
    "target": "total"
   },
   {
    "type": "less_than_or_equal",
    "row": "vulnerable",
    "target": "total"
   }
  ]
 },
 "Employee Turnover": {
  "key": "emp_to",
  "title": "Employee Turnover",
  "unit": "Number",
  "editableAutoTotals": false,
  "columns": [
   {
    "key": "female",
    "label": "Female"
   },
   {
    "key": "male",
    "label": "Male"
   },
   {
    "key": "total",
    "label": "Total"
   }
  ],
  "autoCalculate": {
   "total": [
    "female",
    "male"
   ]
  },
  "rows": [
   {
    "key": "start",
    "label": "Employees at start of year",
    "group": "Headcount",
    "level": 0,
    "brsr": "A-22",
    "gri": "401-1-b",
    "sumOf": null
   },
   {
    "key": "end",
    "label": "Employees at end of year",
    "group": "Headcount",
    "level": 0,
    "brsr": "A-22",
    "gri": "401-1-b",
    "sumOf": null
   },
   {
    "key": "left",
    "label": "Employees leaving (Total)",
    "group": "Employees Leaving",
    "level": 0,
    "brsr": "A-22",
    "gri": "401-1-b",
    "sumOf": null
   },
   {
    "key": "age_u30",
    "label": "Under 30",
    "group": "Employees Leaving",
    "level": 1,
    "brsr": null,
    "gri": "401-1-b",
    "sumOf": null
   },
   {
    "key": "age_3050",
    "label": "30-50",
    "group": "Employees Leaving",
    "level": 1,
    "brsr": null,
    "gri": "401-1-b",
    "sumOf": null
   },
   {
    "key": "age_o50",
    "label": "Over 50",
    "group": "Employees Leaving",
    "level": 1,
    "brsr": null,
    "gri": "401-1-b",
    "sumOf": null
   }
  ],
  "sumOrder": [],
  "fieldMap": {
   "start": {
    "female": "female_employees_at_the_start_of_the_year",
    "male": "male_employees_at_the_start_of_the_year",
    "total": "employees_at_the_start_of_the_year"
   },
   "end": {
    "female": "female_employees_at_the_end_of_the_year",
    "male": "male_employees_at_the_end_of_the_year",
    "total": "employees_at_the_end_of_the_year"
   },
   "left": {
    "female": "female_employees_who_left_during_the_reporting_period",
    "male": "male_employees_who_left_during_the_reporting_period",
    "total": "employees_who_left_during_the_reporting_period"
   },
   "age_u30": {
    "total": "emp_to_age_u30_total"
   },
   "age_3050": {
    "total": "emp_to_age_3050_total"
   },
   "age_o50": {
    "total": "emp_to_age_o50_total"
   }
  },
  "validations": [
   {
    "type": "sum_equals",
    "rows": [
     "age_u30",
     "age_3050",
     "age_o50"
    ],
    "target": "left"
   }
  ]
 },
 "Workers Turnover": {
  "key": "wrk_to",
  "title": "Workers Turnover",
  "unit": "Number",
  "editableAutoTotals": false,
  "columns": [
   {
    "key": "female",
    "label": "Female"
   },
   {
    "key": "male",
    "label": "Male"
   },
   {
    "key": "total",
    "label": "Total"
   }
  ],
  "autoCalculate": {
   "total": [
    "female",
    "male"
   ]
  },
  "rows": [
   {
    "key": "start",
    "label": "Workers at start of year",
    "group": "Headcount",
    "level": 0,
    "brsr": "A-22",
    "gri": "401-1-b",
    "sumOf": null
   },
   {
    "key": "end",
    "label": "Workers at end of year",
    "group": "Headcount",
    "level": 0,
    "brsr": "A-22",
    "gri": "401-1-b",
    "sumOf": null
   },
   {
    "key": "left",
    "label": "Workers leaving (Total)",
    "group": "Workers Leaving",
    "level": 0,
    "brsr": "A-22",
    "gri": "401-1-b",
    "sumOf": null
   }
  ],
  "sumOrder": [],
  "fieldMap": {
   "start": {
    "female": "female_workers_at_the_start_of_the_year",
    "male": "male_workers_at_the_start_of_the_year",
    "total": "workers_at_the_start_of_the_year"
   },
   "end": {
    "female": "female_workers_at_the_end_of_the_year",
    "male": "male_workers_at_the_end_of_the_year",
    "total": "workers_at_the_end_of_the_year"
   },
   "left": {
    "female": "female_workers_who_left_during_the_reporting_period",
    "male": "male_workers_who_left_during_the_reporting_period",
    "total": "workers_who_left_during_the_reporting_period"
   }
  },
  "validations": []
 },
 "Employees Parental Leave": {
  "key": "emp_pl",
  "title": "Employees Parental Leave",
  "editableAutoTotals": false,
  "columns": [
   {
    "key": "female",
    "label": "Female"
   },
   {
    "key": "male",
    "label": "Male"
   }
  ],
  "autoCalculate": {},
  "rows": [
   {
    "key": "entitled",
    "label": "Entitled to parental leave",
    "group": "Parental Leave Funnel",
    "level": 0,
    "brsr": null,
    "gri": "401-3-a",
    "sumOf": null
   },
   {
    "key": "took",
    "label": "Took parental leave",
    "group": "Parental Leave Funnel",
    "level": 0,
    "brsr": "P3-E5",
    "gri": "401-3-b",
    "sumOf": null
   },
   {
    "key": "due_return",
    "label": "Due to return to work",
    "group": "Parental Leave Funnel",
    "level": 0,
    "brsr": "P3-E5",
    "gri": "401-3-e",
    "sumOf": null
   },
   {
    "key": "returned",
    "label": "Returned to work after leave",
    "group": "Parental Leave Funnel",
    "level": 0,
    "brsr": "P3-E5",
    "gri": "401-3-c",
    "sumOf": null
   },
   {
    "key": "retained",
    "label": "Still employed 12 months after return",
    "group": "Parental Leave Funnel",
    "level": 0,
    "brsr": "P3-E5",
    "gri": "401-3-d",
    "sumOf": null
   }
  ],
  "sumOrder": [],
  "fieldMap": {
   "entitled": {
    "female": "emp_pl_entitled_female",
    "male": "emp_pl_entitled_male"
   },
   "took": {
    "female": "no_of_female_employee_took_leave",
    "male": "no_of_male_employee_took_leave"
   },
   "due_return": {
    "female": "female_employees_number_of_employees_that_are_due_to_return_to_work_after_taking_parental_leave",
    "male": "male_employees_number_of_employees_that_are_due_to_return_to_work_after_taking_parental_leave"
   },
   "returned": {
    "female": "female_employees_who_returned_to_work",
    "male": "male_employees_who_returned_to_work"
   },
   "retained": {
    "female": "female_employees_retained_after_12_months",
    "male": "male_employees_retained_after_12_months"
   }
  },
  "validations": [
   {
    "type": "less_than_or_equal",
    "row": "took",
    "target": "entitled"
   },
   {
    "type": "less_than_or_equal",
    "row": "due_return",
    "target": "took"
   },
   {
    "type": "less_than_or_equal",
    "row": "returned",
    "target": "due_return"
   },
   {
    "type": "less_than_or_equal",
    "row": "retained",
    "target": "returned"
   }
  ]
 },
 "Workers Parental Leave": {
  "key": "wrk_pl",
  "title": "Workers Parental Leave",
  "editableAutoTotals": false,
  "columns": [
   {
    "key": "female",
    "label": "Female"
   },
   {
    "key": "male",
    "label": "Male"
   }
  ],
  "autoCalculate": {},
  "rows": [
   {
    "key": "entitled",
    "label": "Entitled to parental leave",
    "group": "Parental Leave Funnel",
    "level": 0,
    "brsr": null,
    "gri": "401-3-a",
    "sumOf": null
   },
   {
    "key": "took",
    "label": "Took parental leave",
    "group": "Parental Leave Funnel",
    "level": 0,
    "brsr": "P3-E5",
    "gri": "401-3-b",
    "sumOf": null
   },
   {
    "key": "due_return",
    "label": "Due to return to work",
    "group": "Parental Leave Funnel",
    "level": 0,
    "brsr": "P3-E5",
    "gri": "401-3-e",
    "sumOf": null
   },
   {
    "key": "returned",
    "label": "Returned to work after leave",
    "group": "Parental Leave Funnel",
    "level": 0,
    "brsr": "P3-E5",
    "gri": "401-3-c",
    "sumOf": null
   },
   {
    "key": "retained",
    "label": "Still employed 12 months after return",
    "group": "Parental Leave Funnel",
    "level": 0,
    "brsr": "P3-E5",
    "gri": "401-3-d",
    "sumOf": null
   }
  ],
  "sumOrder": [],
  "fieldMap": {
   "entitled": {
    "female": "wrk_pl_entitled_female",
    "male": "wrk_pl_entitled_male"
   },
   "took": {
    "female": "no_of_female_workers_that_took_leave",
    "male": "no_of_male_workers_took_leave"
   },
   "due_return": {
    "female": "female_workers_that_are_due_to_return_to_work_after_taking_parental_leave",
    "male": "male_workers_that_are_due_to_return_to_work_after_taking_parental_leave"
   },
   "returned": {
    "female": "female_workers_who_returned_to_work",
    "male": "male_workers_who_returned_to_work"
   },
   "retained": {
    "female": "female_workers_retained_after_12_months",
    "male": "male_workers_retained_after_12_months"
   }
  },
  "validations": [
   {
    "type": "less_than_or_equal",
    "row": "took",
    "target": "entitled"
   },
   {
    "type": "less_than_or_equal",
    "row": "due_return",
    "target": "took"
   },
   {
    "type": "less_than_or_equal",
    "row": "returned",
    "target": "due_return"
   },
   {
    "type": "less_than_or_equal",
    "row": "retained",
    "target": "returned"
   }
  ]
 }
};
